module.exports = __webpack_public_path__ + "img/home1-0.55d9bbaf.jpg";